const LINKS = {
    sport:
        'https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_content=sport&utm_campaign=KIA_Sportage_Tactic_December_2018',
    career:
        'https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_content=career&utm_campaign=KIA_Sportage_Tactic_December_2018',
    family:
        'https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_content=family&utm_campaign=KIA_Sportage_Tactic_December_2018',
    business:
        'https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_content=business&utm_campaign=KIA_Sportage_Tactic_December_2018',
    art:
        'https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_content=art&utm_campaign=KIA_Sportage_Tactic_December_2018',
}
export default LINKS;